  document.addEventListener('DOMContentLoaded', function () {

    $(".sticky-container .sticky-container-inner").slimScroll({
      width: 'auto', //可滚动区域宽度
      height: '100%', //可滚动区域高度
      size: '4px', //组件宽度
      color: 'rgb(184, 180, 178)', //滚动条颜色
      position: 'right', //组件位置：left/right
      distance: '0px', //组件与侧边之间的距离
      start: 'top', //默认滚动位置：top/bottom
      opacity: 0, //滚动条透明度
      alwaysVisible: false, //是否 始终显示组件
      disableFadeOut: true, //是否 鼠标经过可滚动区域时显示组件，离开时隐藏组件
      railVisible: true, //是否 显示轨道
      railColor: 'rgb(232, 231, 230)', //轨道颜色
      railOpacity: 1, //轨道透明度
      railDraggable: true, //是否 滚动条可拖动
      railClass: 'slimScrollRail', //轨道div类名 
      barClass: 'slimScrollBar', //滚动条div类名
      wrapperClass: 'slimScrollDiv', //外包div类名
      allowPageScroll: true, //是否 使用滚轮到达顶端/底端时，滚动窗口
      wheelStep: 10, //滚轮滚动量
      touchScrollStep: 10, //滚动量当用户使用手势
      borderRadius: '7px', //滚动条圆角
      railBorderRadius: '7px' //轨道圆角
    });

    // 页面滚动到对应标题 id 时，自动高亮目录里的当前项。
    var tocItems = Array.prototype.slice.call(document.querySelectorAll('.table-of-contents ul li'));
    var tocTargets = tocItems.map(function (item) {
      var link = item.querySelector('a[href^="#"]');
      var targetIds = [];

      if (link) {
        targetIds.push(link.getAttribute('href').replace(/^#/, ''));
      }

      if (item.dataset.target) {
        targetIds.push(item.dataset.target.replace(/^#/, ''));
      }

      var targetElement = targetIds.reduce(function (matchedElement, targetId) {
        if (matchedElement || !targetId) return matchedElement;
        return document.getElementById(decodeURIComponent(targetId));
      }, null);

      return {
        item: item,
        element: targetElement
      };
    }).filter(function (target) {
      return target.element;
    });

    function updateActiveTocItem() {
      if (!tocTargets.length) return;

      var activeTarget = tocTargets[0];
      var triggerTop = window.scrollY + window.innerHeight * 0.6;

      tocTargets.forEach(function (target) {
        var targetTop = target.element.getBoundingClientRect().top + window.scrollY;
        if (targetTop <= triggerTop) {
          activeTarget = target;
        }
      });

      tocItems.forEach(function (item) {
        item.classList.toggle('title-scroll-active', item === activeTarget.item);
      });
    }

    window.addEventListener('scroll', updateActiveTocItem, { passive: true });
    window.addEventListener('resize', updateActiveTocItem);
    updateActiveTocItem();

    // 控制左侧 sticky 模块的隐藏和展开状态，使用事件委托避免 slimScroll 包裹 DOM 后绑定失效。
    document.addEventListener('click', function (event) {
      var hideToggle = event.target.closest('[data-sticky-hide-toggle]');
      var mobileToggle = event.target.closest('[data-sticky-mobile-toggle]');
      var wrapperClass = document.querySelector('.article-template__content');
      var recommendWrapperClass = document.querySelector('.recommend-blog .main-container');
      
      if (!hideToggle && !mobileToggle) return;

      var stickySidebar = event.target.closest('[data-sticky-blog-sidebar]');
      if (!stickySidebar) return;

      var currentHideToggle = stickySidebar.querySelector('[data-sticky-hide-toggle]');
      var currentMobileToggle = stickySidebar.querySelector('[data-sticky-mobile-toggle]');

      if (hideToggle) {
        stickySidebar.classList.add('is-hidden');
        stickySidebar.classList.remove('is-open');
        hideToggle.setAttribute('aria-expanded', 'false');
        wrapperClass.classList.add('is-hidden');
        recommendWrapperClass.classList.add('is-hidden');
        if (currentMobileToggle) {
          currentMobileToggle.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      var isHidden = stickySidebar.classList.toggle('is-hidden');
      stickySidebar.classList.toggle('is-open', !isHidden);
      mobileToggle.setAttribute('aria-expanded', String(!isHidden));
      wrapperClass.classList.remove('is-hidden');
      recommendWrapperClass.classList.remove('is-hidden');
      if (currentHideToggle) {
        currentHideToggle.setAttribute('aria-expanded', String(!isHidden));
      }
    });

    // 点击优惠码时复制文本，并短暂显示复制成功状态。
    document.querySelectorAll('[data-discount-code]').forEach(function (button) {
      button.addEventListener('click', function () {
        var code = button.getAttribute('data-discount-code');
        if (!code || !navigator.clipboard) return;

        navigator.clipboard.writeText(code).then(function () {
          button.classList.add('is-copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 1600);
        });
      });
    });
  });